import { Component, Input, OnInit, inject, input, output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { Stakeholder } from 'src/app/models/stakeholder.model';
import { StakeholderService } from 'src/app/services/stakeholder.service';
import { emailRegex } from 'src/app/shared/validation.util';
import { NgClass } from '@angular/common';
import { MatFormField, MatInput, MatError } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-stakeholders-table',
    templateUrl: './stakeholders-table.component.html',
    styleUrls: ['./stakeholders-table.component.scss'],
    imports: [MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, NgClass, MatCellDef, MatCell, MatFormField, MatInput, ReactiveFormsModule, MatError, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatButton]
})
export class StakeholdersTableComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  private stakeholderService = inject(StakeholderService);

  public displayedColumns: string[] = ['name', 'organisation', 'email', 'action'];
  public dataSource = new MatTableDataSource<any>();

  private items!: FormArray;

  readonly supportingParty = input(false);

  @Input() stakeholderForm!: FormGroup<any>;

  readonly dataUpdated = output<FormGroup<any>>();

  ngOnInit() {
    this.stakeholderForm = this.formBuilder.group({
      items: this.formBuilder.array([])
    });
    this.stakeholderForm.valueChanges.subscribe(() => this.dataUpdated.emit(this.stakeholderForm));
    this.items = this.stakeholderForm.get('items') as FormArray;
    this.stakeholderService.getStakeholders().subscribe(stakeholders => {
      const filtered = stakeholders.filter(stakeholder => stakeholder.supporting === this.supportingParty());
      filtered.forEach(stakeholder => this.addInput(stakeholder));
      if (filtered.length === 0) this.addInput();
    });
  }

  public addInput(stakeholder?: Stakeholder) {
    const stakeholderGroup: FormGroup<any> = this.getStakeHolderFormGroup(stakeholder);
    if (stakeholder) {
      this.items.controls.unshift(stakeholderGroup);
    } else {
      this.items.push(stakeholderGroup);
    }
    this.dataSource.data = this.items.controls;
  }

  public removeInput(index: number) {
    this.items.removeAt(index);
    this.dataSource.data = this.items.controls;
  }

  public error(control: FormControl, errorName: string): boolean {
    return control.hasError(errorName) && (control.touched || control.dirty);
  }

  private getStakeHolderFormGroup(stakeholder?: Stakeholder) {
    const stakeholderGroup: FormGroup<{}> = this.formBuilder.group({});

    stakeholder = stakeholder ?? {
      ssoId: '',
      name: '',
      email: '',
      organisation: ''
    };

    Object.entries(stakeholder)
      .forEach(([key, value]) => {
        stakeholderGroup.addControl(
          key,
          this.formBuilder.nonNullable.control(value, this.getValidatorsOnFormControlName(key))
        );
      });

    return stakeholderGroup;
  }

  private getValidatorsOnFormControlName(formControlName: string): {} {
    const emailValidator = { validators: [Validators.required, Validators.pattern(emailRegex)], updateOn: 'blur' };
    switch (formControlName) {
      case 'email':
        return emailValidator;
      case 'supporting':
      case 'phonenumber':
      case 'ssoId':
        return { updateOn: 'blur' };
      default:
        return { validators: [Validators.required], updateOn: 'blur' };
    }
  }
}